export interface SiteMenuOption {
    menu_name: string;
    menu_key_name: string;
    shared_project_count: number;
}

export const mapSiteMenuOption = (data: any): SiteMenuOption => {
    if (!data) {
        throw new Error('Invalied SiteMenuOption type')
    }

    const SowSubSections: SiteMenuOption = {
        menu_name: data.menu_name,
        menu_key_name: data.menu_key_name,
        shared_project_count: data.shared_project_count,
    }

    return SowSubSections;
}

export const mapSiteMenuOptions = (data: any[]): SiteMenuOption[] => {
    if (!Array.isArray(data)) {
        throw new Error('Invalid SiteMenuOption data');
    }

    return data.map(mapSiteMenuOption);
};